import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useState } from 'react';
import AppDrawer from '../components/common/AppDrawer';
import AddPendingTask from '../components/dashboard/AddPendingTask';
import { BasePageLayout } from './../design/layouts/page/base';

import type { NextPage } from 'next';
import { useEffect } from 'react';
import { useAuthCtx } from '../modules/helpers/contexts/auth';
import { useRouter } from 'next/router';
import useSession from '../services/store/session-store';
import DeviceVerification from '../components/auth/verify-code/DeviceVerification';

const DynamicNews = dynamic(() => import('packages/workspace/components/dashboard/News'));
const DynamicPendingTasks = dynamic(() => import('packages/workspace/components/dashboard/PendingTask'));
const DynamicQuickLinks = dynamic(() => import('packages/workspace/components/dashboard/QuickLinks'));

const Index: NextPage = () => {
  const { iamPrincipal } = useSession();
  const [isDeviceVerified, setDeviceVerified] = useState(false);
  const [drawerState, setDrawerState] = useState({
    anchor: { right: false },
  });
  const { loading, system_user } = useAuthCtx();
  const router = useRouter();

  const [isDrawerOpen, setDrawerOpen] = useState({ open: false, id: '', name: '' });

  const toggleDrawer = (anchor: string, open: boolean) => {
    setDrawerState({
      ...drawerState,
      anchor: { ...drawerState.anchor, [anchor]: open },
    });
  };

  const onTaskClick = (id: string, name: string) => {
    setDrawerOpen({ open: true, id, name });
    toggleDrawer('right', true);
  };
  useEffect(() => {
    if (!loading && system_user && system_user.reportals && system_user.reportals.privileged_reports_enabled) {
      router.push(`privileged/${system_user.reportals.privileged_reports_id}`);
    }
  }, [system_user, loading]);

  return (
    !isDeviceVerified &&
      iamPrincipal &&
      iamPrincipal.security &&
      iamPrincipal.security.ip_authentication_required ?
      <DeviceVerification setDeviceVerified={setDeviceVerified} /> :
      <>
        <Head>
          <title>Launchpad</title>
        </Head>
        {system_user && (
          <BasePageLayout>
            <div style={{ height: '75vh' }} className="w-full flex flex-col items-center justify-center h-5/6">
              <div className="flex w-9/12 h-5/6 gap-5">
                <div className="w-6/12 grid grid-rows-2 h-full gap-5">
                  <DynamicPendingTasks onTaskClick={onTaskClick} />
                  <DynamicQuickLinks />
                </div>
                <div className="w-6/12  h-full border border-tc-6 rounded-xl bg-tc-1">
                  <DynamicNews />
                </div>
              </div>
            </div>
            <AppDrawer className="rhs-drawer wd-520" open={drawerState.anchor.right}>
              <AddPendingTask
                onClose={() => {
                  setDrawerOpen({ open: false, id: '', name: '' });
                  toggleDrawer('right', false);
                }}
                document_id=""
                isDrawerOpen={isDrawerOpen}
              />
            </AppDrawer>
          </BasePageLayout>
        )}
      </>
  );
};

export default Index;
